const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contatti",
  description: "Benvenuto nell'Area Contatti di BRIDGESTONE PLUS.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Team commercio pneumatici",
    car: "Team concessionarie auto",
    lkw: "Team autocarri",
    em_otr: "Team EM/OTR",
    farm_tractor: "Team trattori agricoli",
    bandag: "Team Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
